const theme = {
  palette: {
    primary: {
      main: "#302e2f"
    }
  },
  shape: {
    borderRadius: 10
  },
  typography: {
    fontFamily: [
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
    ].join(","),
  },
};

export default theme;
